import { create } from "sheetly";
export let text = "div.actions{display:flex;flex-direction:row-reverse}dialog{width:fit-content}div.modal-content{display:flex;flex-direction:column;align-items:center}";
export const sheet = create(text, import.meta.url);
